import { DateTime } from 'luxon'

import { Letter } from 'state/letter/types'

import { CellProps } from 'components/ui'
import { Wrapper, Title, Value } from '../Style'

export function CreatedAt({ row }: CellProps<Letter>) {
  const { createdAt } = row.original

  const formattedDate = DateTime.fromISO(createdAt.toString()).toFormat('dd.MM.yyyy HH:mm')

  return (
    <Wrapper area='CreatedAt'>
      <Title>Created</Title>
      <Value>{formattedDate}</Value>
    </Wrapper>
  )
}
